<template>
  <el-dropdown
    class="right-menu-item hover-effect"
    id="chgLang"
    @command="handleLanguage"
  >
    <div>
      <template v-if="iconSize != null">
        <i class="fa ly-icon-lang fa-lg" :style="{ fontSize: iconSize,marginTop: '19px' }"></i>
      </template>
      <template v-else>
        <i class="fa ly-icon-lang fa-lg"></i>
      </template>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item of langs"
        :key="item.value"
        :disabled="size === item.value"
        :command="item.value"
        >{{ item.label }}</el-dropdown-item
      >
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  props: {
    iconSize: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      langs: [
        { value: "en_US", label: "English" },
        { value: "zh_CN", label: "简体中文" },
        { value: "zh_TW", label: "繁體中文" },
      ],
    };
  },
  computed: {
    size() {
      return localStorage.getItem("language") || "en_US";
    },
  },
  methods: {
    handleLanguage(lang) {
      localStorage.setItem("language", lang);
      // 未登錄按鈕
      localStorage.setItem("lang-reLogin", this.$t("PUB.reLogin"));
      localStorage.setItem("lang-cancel", this.$t("PUB.cancel"));
      localStorage.setItem("lang-sysTips", this.$t("PUB.sysTips"));
      location.reload();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Language/index.vue